(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osprey-contact"]) return;
  try {
    
  function ospreyContactInit(){const params=new URLSearchParams(location.search);const topic=document.querySelector('#ow-contact-topic');const ref=document.querySelector('#ow-contact-product');if(topic&&['equipment-fit','order-help','professional','other'].includes(params.get('subject')))topic.value=params.get('subject');if(ref&&params.get('model'))ref.value=params.get('model').slice(0,200);}
  document.addEventListener('DOMContentLoaded',ospreyContactInit);if(document.readyState!=='loading')ospreyContactInit();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osprey-record"]) return;
  try {
    
  function ospreyRecordInit() { document.querySelectorAll('[data-ow-record]').forEach(sheet=>{ if(sheet.dataset.ready) return; sheet.dataset.ready='true'; const params=new URLSearchParams(location.search); const model=params.get('model'); const topic=params.get('topic'); const equipment=sheet.querySelector('[name="equipment"]'); if(model) equipment.value=model.slice(0,200); if(['water','fire','air','land'].includes(topic)) sheet.querySelector('[name="element"]').value=topic; const fields=Array.from(sheet.querySelectorAll('[data-record-field]')); const status=sheet.querySelector('[data-record-status]'); const resize=()=>fields.filter(f=>f.tagName==='TEXTAREA').forEach(f=>{f.style.height='auto';f.style.height=Math.max(125,f.scrollHeight+4)+'px';}); fields.forEach(f=>f.addEventListener('input',resize)); sheet.querySelector('[data-record-download]').addEventListener('click',()=>{if(!equipment.value.trim()){status.textContent=sheet.dataset.empty;equipment.focus();return;} const parts=['OspreyWatch Shop — '+sheet.dataset.title,sheet.dataset.notice,sheet.dataset.date+': '+new Date().toLocaleDateString(),'']; fields.forEach(f=>{const label=document.querySelector('label[for="'+f.id+'"]');const value=f.tagName==='SELECT'?f.options[f.selectedIndex].text:f.value;parts.push(label.textContent.trim(),value.trim()||'—','');}); const url=URL.createObjectURL(new Blob([parts.join('\n')],{type:'text/plain;charset=utf-8'}));const a=document.createElement('a');a.href=url;a.download='OspreyWatch-Protection-Record.txt';document.body.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);status.textContent=sheet.dataset.downloaded;});sheet.querySelector('[data-record-print]').addEventListener('click',()=>{resize();window.print();});sheet.querySelector('[data-record-clear]').addEventListener('click',()=>{if(!window.confirm(sheet.dataset.clearConfirm))return;fields.forEach(f=>f.value='');status.textContent='';resize();equipment.focus();}); }); }
  document.addEventListener('DOMContentLoaded',ospreyRecordInit);document.addEventListener('shopify:section:load',ospreyRecordInit);if(document.readyState!=='loading')ospreyRecordInit();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osprey-shop"] && !Shopify.designMode) return;
  try {
    
  function ospreyEntry() { const panel=document.querySelector('[data-ow-entry]'); const copy=document.querySelector('[data-ow-entry-copy]'); if(!panel||!copy) return; const source=new URLSearchParams(location.search).get('from'); if(!['risk-check','article','owned','professional','order'].includes(source)) return; panel.querySelector('[data-ow-entry-title]').textContent=copy.getAttribute('data-'+source); panel.hidden=false; }
  document.addEventListener('DOMContentLoaded',ospreyEntry); document.addEventListener('shopify:section:load',ospreyEntry); if(document.readyState!=='loading') ospreyEntry();

  } catch(e) { console.error(e); }
})();
})();
